import { STOCK_ITEM_TYPES, STOCK_STATUSES } from "@artisancode/api-types";
import { z } from "zod";

export const stockItemSchema = z.object({
  id: z.string(),
  itemId: z.string(),
  name: z.string().min(1, "Nama barang wajib diisi"),
  sku: z.string().nullable().optional(),
  type: z.enum(STOCK_ITEM_TYPES),
  categoryName: z.string(),
  uomName: z.string(),
  currentStock: z.number().min(0, "Stok tidak boleh negatif"),
  minStock: z.number().min(0, "Batas minimum tidak boleh negatif"),
  costPerUnit: z.number().min(0),
  totalValue: z.number().min(0),
  status: z.enum(STOCK_STATUSES),
  notes: z.string().nullable().optional(),
});

export type StockItemFormValues = z.infer<typeof stockItemSchema>;

export const stockFilterSchema = z.object({
  query: z.string().default(""),
  type: z.enum(["all", ...STOCK_ITEM_TYPES]).default("all"),
  status: z.enum(["all", ...STOCK_STATUSES]).default("all"),
});

export type StockFilterValues = z.infer<typeof stockFilterSchema>;

export const editMinStockSchema = z.object({
  minStock: z
    .number({ message: "Batas minimum harus berupa angka" })
    .min(0, "Batas minimum tidak boleh negatif"),
});

export type EditMinStockFormValues = z.infer<typeof editMinStockSchema>;
